import {API} from '../../api.js';
import {getAuthHeader, handleErrors} from '../../helpers/helpers.js';

const baseUrl = API.url + '/resources';

const TYPE_PREFIX = 'RESOURCE';

const types = {
  RESOURCE_LOAD: `${TYPE_PREFIX}_LOAD`,
  RESOURCE_LOAD_SUCCESS: `${TYPE_PREFIX}_LOAD_SUCCESS`,
  RESOURCE_LOAD_FAILED: `${TYPE_PREFIX}_LOAD_FAILED`,

  RESOURCE_ADD: `${TYPE_PREFIX}_ADD`,
  RESOURCE_ADD_SUCCESS: `${TYPE_PREFIX}_ADD_SUCCESS`,
  RESOURCE_ADD_FAILED: `${TYPE_PREFIX}_ADD_FAILED`,

  RESOURCE_UPDATE: `${TYPE_PREFIX}_UPDATE`,
  RESOURCE_UPDATE_SUCCESS: `${TYPE_PREFIX}_UPDATE_SUCCESS`,
  RESOURCE_UPDATE_FAILED: `${TYPE_PREFIX}_UPDATE_FAILED`,

  RESOURCE_DELETE: `${TYPE_PREFIX}_DELETE`,
  RESOURCE_DELETE_SUCCESS: `${TYPE_PREFIX}_DELETE_SUCCESS`,
  RESOURCE_DELETE_FAILED: `${TYPE_PREFIX}_DELETE_FAILED`,
}

const state = {
  isLoading: false,
  resource: {
    title: ''
  },
  resources: []
};

const getters = {
  isLoadingResources: state => state.isLoading,
  resource: state => state.resource,
  getAllResources: state => state.resources,
  getResourceById: state => index => state.resources.filter(resource => resource.id == index)[0],
};

const actions = {
  loadAllResources({ commit }) {
    return new Promise((resolve, reject) => {
      commit(types.RESOURCE_LOAD);

      fetch(baseUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getAuthHeader()
        },
      })
        .then(handleErrors)
        .then(data => data.json())
        .then(response => {
          commit(types.RESOURCE_LOAD_SUCCESS, response)
          resolve();
        })
        .catch(err => {
          console.error(err);
          commit(types.RESOURCE_LOAD_FAILED);
          reject();
        });
    });
  },

  getResource({ commit }, id) {

  },

  addResource({ commit, state }, resource) {
    const resources = [...state.resources];
    commit(types.RESOURCE_ADD, resource);

    fetch(baseUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthHeader()
      },
      body: JSON.stringify(resource)
    })
      .then(handleErrors)
      .then(data => data.json())
      .then(response => commit(types.RESOURCE_ADD_SUCCESS, response))
      .catch(err => {
        console.error(err);
        commit(types.RESOURCE_ADD_FAILED, resources);
      });
  },

  updateResource({ commit }, resource) {
    const resources = [...state.resources];
    commit(types.RESOURCE_UPDATE, resource);

    fetch(baseUrl + `/${resource.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthHeader()
      },
      body: JSON.stringify(resource)
    })
      .then(handleErrors)
      .then(data => data.json())
      .then(response => commit(types.RESOURCE_UPDATE_SUCCESS, response))
      .catch(err => {
        console.error(err);
        commit(types.RESOURCE_UPDATE_FAILED, resources);
      });
  },

  deleteResource({ commit }, id) {
    const resources = [...state.resources];
    commit(types.RESOURCE_DELETE, { id });

    fetch(baseUrl + `/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthHeader()
      },
    })
      .then(handleErrors)
      .then(response => commit(types.RESOURCE_DELETE_SUCCESS, response))
      .catch(err => {
        console.error(err);
        commit(type.RESOURCE_DELETE_FAILED, resources);
      });
  }
};

const mutations = {
  loadingState(state, { isLoading }) {
    state.isLoading = isLoading;
  },

  [types.RESOURCE_LOAD] (state) {
    state.isLoading = true;
  },
  [types.RESOURCE_LOAD_SUCCESS] (state, resources) {
    state.resources = resources;
    state.isLoading = false;
  },
  [types.RESOURCE_LOAD_FAILED] (state) {
    state.isLoading = false;
  },

  [types.RESOURCE_ADD] (state, resource) {
    state.resources = [
      ...state.resources,
      resource
    ];
  },
  [types.RESOURCE_ADD_SUCCESS] (state, response) {
    state.resources.pop();
    state.resources = [
      ...state.resources,
      response
    ];
  },
  [types.RESOURCE_ADD_FAILED] (state, resources) {
    state.resources = resources;
  },

  [types.RESOURCE_UPDATE] (state, resource) {

  },
  [types.RESOURCE_UPDATE_SUCCESS] (state, response) {
    // console.log(response);
  },
  [types.RESOURCE_UPDATE_FAILED] (state, resources) {
    state.resources= resources;
  },

  [types.RESOURCE_DELETE] (state, { id }) {
    state.resources = state.resources.filter(resource => resource.id != id);
  },
  [types.RESOURCE_DELETE_SUCCESS] (state, response) {
    // console.log(response);
  },
  [types.RESOURCE_DELETE_FAILED] (state, resources) {
    state.resources = resources;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/resources.js